import { useEffect, useState } from "react";
import API from "../../api/axios";
import { APP_URLS } from "../../api/url";
import { toast } from "react-toastify";
import { APIError, getProductTypeName } from "../../core/utils";
import RecordCount from "../../assets/SharedComponents/RecordCount/RecordCount";
import { Tooltip } from "@mui/material";
import { FaCompany, FaFilterIcon, FaUser } from "../../assets/Images/icon";
import { ThreeDots } from "react-loader-spinner";
import NoRecord from "../../assets/SharedComponents/Table/NoRecord";
import Pagination from "../../assets/SharedComponents/Pagination";
import { Wrapper } from "./style/style";
import back from "../../assets/Images/icons/svgIcon/back-arrow.svg";
import { typeOfSale, typeOfSaleInverse } from "../../config/constant";
import ReportHistoryModal from "../reportedAds/Components/reportHistoryModal";
import { useNavigate } from "react-router-dom";
import ProductTypeFilter from "../../assets/SharedComponents/Filters/ProductTypeFilter";

const ReportedAdsHistory = () => {
  const navigate = useNavigate();
  const [ads, _ads] = useState([]);
  const [page, setPage] = useState(1);
  const [product, _product] = useState("");
  const [total, _total] = useState(0);
  const [totalPage, _totalPage] = useState(0);
  const [filters, _filters] = useState(false);

  const [countValue, _countValue] = useState(10);

  const [adsloader, _adsloader] = useState(false);
  const [actionloader, _actionloader] = useState(false);

  useEffect(() => {
    getReportedAds();
  }, [page, countValue, product]);

  const getReportedAds = () => {
    _adsloader(true);
    API.get(
      `${APP_URLS.REPORTED_ADS}?history_page=1&page=${page}&per_page=${countValue}&product_type=${product}`
    )
      .then((res) => {
        const resp = res.data;
        if (resp.success === true) {
          _ads(resp.data.data);
          _total(resp.data.total);
          _totalPage(resp.data.last_page);
        } else {
          toast.error(resp.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(function (error) {
        let error_message = APIError(error);
        toast.error(error_message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .finally(() => {
        _adsloader(false);
      });
  };

  const handleChange = (searchValue) => {
    _countValue(searchValue);
    _totalPage(0);
    setPage(1);
  };

  //removing all filters
  const clearFilter = () => {
    _filters(true);
    _countValue(10);
    _product("");
    _totalPage(0);
    setPage(1);
  };

  const showBadge = (source) => {
    if (source === "subsidiary") return <FaCompany className="profileIcon" />;
    return <FaUser className="profileIcon" />;
  };

  const handleNavigate = (ad) => {
    const adType =
      ad.type_of_sale === typeOfSaleInverse.Classic
        ? "/public-ads"
        : ad.type_of_sale === typeOfSaleInverse.Auction
        ? "/auction-ads"
        : "/hot-deal";
    const url = `${process.env.REACT_APP_FRONTOFFICE_URL_HTTPS}/fr${adType}/${ad.ad_slug}`;
    window.open(url, "_blank");
  };

  return (
    <>
      <Wrapper>
        <div className="auctionMainContainer">
          <div className="row mt-4">
            <div className="col-md-4 d-flex align-items-center">
              <img
                src={back}
                className="ms-4 backbtn"
                onClick={() => navigate("/reported-ads")}
              />
            </div>
            <div className="col-md-4 text-align-center">
              <h1>REPORTED ADS HISTORY</h1>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-between info-wrap mt-3 mb-2">
            <div className="justify-content-end mt-1 me-2">
              <span className="text-start">
                Total Records : <b>{total}</b>
              </span>
            </div>
            <div className="justify-content-end mt-4 d-flex gap-2 mb-2 select-info align-items-center">
              <ProductTypeFilter
                handleChange={(e) => {
                  _product(e.target.value);
                  _totalPage(0);
                  setPage(1);
                }}
                value={product}
              />
              <RecordCount
                onSearchClick={(search) => handleChange(search)}
                id="pageCount"
                val={countValue}
                filters={filters}
                _filters={_filters}
              />
              <Tooltip title="Clear Filter" placement="bottom">
                <FaFilterIcon
                  className="filter-icon"
                  role="button"
                  onClick={clearFilter}
                />
              </Tooltip>
            </div>
          </div>
          <div className="tableContainer">
            <table className="auctionTable">
              <thead className="tableHead">
                <tr className="table-row">
                  <th>Ad ID</th>
                  <th>Ad Name</th>
                  <th>Ad Created by</th>
                  <th>Type of sale</th>
                  <th>Product Type</th>
                  <th>Ad Report Count</th>
                  <th>Report History</th>
                </tr>
              </thead>
              {adsloader ? (
                <div className="d-flex justify-content-center three-dot">
                  <ThreeDots
                    height="150"
                    width="150"
                    radius="9"
                    color="#637df4"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                </div>
              ) : (
                <tbody>
                  {ads.length > 0 ? (
                    ads.map((ad) => {
                      return (
                        <tr
                          className={`table-row ${
                            ad.deleted_at ? "deletedRow" : ""
                          }`}
                          key={`${ad.ad_title} ${ad.id}`}
                        >
                          <td>{ad.id}</td>
                          <td
                            className="link"
                            onClick={() => handleNavigate(ad)}
                          >
                            <b>{ad.ad_full_title}</b>
                          </td>
                          <td className="userName">
                            <a
                              href={`${
                                ad.source === "subsidiary"
                                  ? "/company-details"
                                  : "/detail-member"
                              }/${ad.user_id}`}
                              className="link"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <b>
                                {ad.user_name}
                                {showBadge(ad.source)}
                              </b>
                            </a>
                          </td>
                          <td>{typeOfSale[ad.type_of_sale]} Ad</td>
                          <td>
                            {ad.product_type_id
                              ? getProductTypeName(ad.product_type_id)
                              : "-"}{" "}
                          </td>
                          <td>{ad.reported_count ?? "-"}</td>
                          <td>
                            {" "}
                            <ReportHistoryModal title={"Ad Name"} id={ad.id} />
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <NoRecord />
                  )}
                </tbody>
              )}
            </table>
          </div>
          <div>
            {totalPage > 1 ? (
              <Pagination
                totalPages={totalPage}
                page={page}
                key={totalPage}
                onPageClick={(page) => setPage(page + 1)}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default ReportedAdsHistory;
